export default __webpack_public_path__ + "static/media/avatar.b81a89ab.svg";